import * as userRoutines from '../../sagas/routines/userRoutines';
import { connect } from 'react-redux';
import { getActiveEventName } from '../Events/selectors';
import { makeActiveChannelMessages, makeActiveChannelName } from './channelsSelectors';
import { removeChannel, sendMessageAsAlertUser, syncChannels, toggleBlockChannelMessage } from './channelRoutines';
import { setChannelEditing } from '../../redux/ui/actions';
import ChannelView from '../../Components/Channels/ChannelView';

const mapState2Props = (state: any) => {
    return {
        channel_name: makeActiveChannelName(state),
        event_name: getActiveEventName(state),
        messages: makeActiveChannelMessages(state),
    };
};
const mapDispatchToProps = {
    fetchUserAvatar: userRoutines.fetchUserAvatar,
    removeChannel,
    sendMessageAsAlertUser,
    setChannelEditing,
    syncChannels,
    toggleBlockChannelMessage,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(ChannelView);
